export const subjectConstants = {
    START: 'subject:start',
    STOP: 'subject:stop',
    SUBJECT: 'subject:subject',
    ADD: 'subject:add',
    UPDATE: 'subject:update',
    REMOVE: 'subject:delete',
    CLEAR: 'subject:clear',
};